import { GenericFailure } from '@playq/services-shared';
import { ClusterizationRunId, ClusterizationTaskId, IngestionConfig } from '@playq/services-beetle';
import { Environment } from '@playq/octopus-common';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

export const useRunTask = (
  options?: UseMutationOptionsExtended<
    ClusterizationRunId,
    GenericFailure | Error,
    {
      taskId: ClusterizationTaskId;
      ingestionConfig: IngestionConfig;
      env: Environment;
    }
  >
) => {
  return useEitherMutation(
    ({ taskId, ingestionConfig, env }) =>
      services2.audienceRequestsClusterizationService.start(taskId, ingestionConfig, env),
    {
      ...options,
    }
  );
};
